var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4 13.355c0 7.924-5.373 13.451-13.2 13.451-7.827 0-13.2-5.527-13.2-13.45 0-1.266.133-2.398.398-3.53.066-.133.265-.2.398-.133l3.648 1.998c1.194.732 1.393 1.664 1.46 2.33.198 4.662 3.183 7.858 7.362 7.858 4.378 0 7.43-3.396 7.43-8.39 0-4.928-3.118-8.39-7.43-8.39-2.918 0-5.24 1.53-6.434 4.061 0 .067-.133.134-.199.134H.995c-.2 0-.332-.2-.265-.333C2.388 3.567 7.03.104 13.266.104c7.761 0 13.2 5.46 13.134 13.251z",
    fill: "#37AAE1",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.7a74e154637f8343a33864c4cf4fe4ae.svg";
export { ForwardRef as ReactComponent };